// Shopify cart URL — adds the product variant to the cart and lands on /cart
export const CART_LINK = 'https://templodigital.shop/cart/42766407499847:1'
